import { commentLikeLink } from "../routes";

export default {
    methods: {
        likeComment(comment) {
            // Optimistically mark comment as liked
            this.addCommentToLikedItems(comment);

            window.axios
                .put(commentLikeLink(comment))
                .catch(() => {
                    this.$toast.danger(this.trans('Comment could not be liked.'));

                    // As we failed remove like that we added optimistically
                    this.removeCommentFromLikedItems(comment);
                });
        },
        dislikeComment(comment) {
            // Optimistically dislike the comment
            this.removeCommentFromLikedItems(comment);

            window.axios
                .delete(commentLikeLink(comment))
                .catch(() => {
                    this.$toast.danger(this.trans('Comment could not be disliked.'));

                    // As we failed remove like that we added optimistically
                    this.addCommentToLikedItems(comment);
                });
        },
        removeCommentFromLikedItems(comment) {
            const item = this.items.find((item) => item.encoded_id === comment.encoded_id);
            if (item) {
                item.likes_count--;
                item.is_liked = false;
            }
        },
        addCommentToLikedItems(comment) {
            const item = this.items.find((item) => item.encoded_id === comment.encoded_id);
            if (item) {
                item.likes_count++;
                item.is_liked = true;
            }
        },
        likesCount(comment) {
            if (comment.likes_count === 1) {
                return this.trans('1 like');
            }

            return this.trans(':count likes', {'count': comment.likes_count});
        },
    }
}